
import { slotSeeker } from '@/utils';

export default {
  functional: true,
  render() {
    return slotSeeker('panelmenu-slot-top');
  },
};
